// Module
var code = "<div id=\"{{id}}\" class=\"dc-section-loading\"> <div class=\"lds-roller\"> <div></div> <div></div> <div></div> <div></div> <div></div> <div></div> <div></div> <div></div> </div> </div>";
// Exports
module.exports = code;